import React from 'react';
import MaterialAvatar from "@material-ui/core/Avatar";
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  medium: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  flex: {
    width: "100%",
    height: "100%"
  },
  flexHeight: {
    height: "100%"
  },
  avatarTheme: ({bgColor, fontSize, color, ...rest})=>{
      return {
      backgroundColor: bgColor,
      color: color? color: theme.palette.getContrastText(bgColor),
      fontSize: theme.spacing(fontSize),
      ...rest
  }}
}));

const Avatar = (props) => {
    const {src = "", alt = "", variant, children, size = "small", isList = false, avatarStyle: {bgColor="transparent", fontSize = 3, color, ...restStyle} = {}} = props
    const classes = useStyles({bgColor, fontSize, color, ...restStyle})
    const Wrapper = isList? ListItemAvatar: React.Fragment

    return (
    <Wrapper>
    <MaterialAvatar alt={alt} src={src} variant={variant} className = {classes[size]+" "+classes.avatarTheme}>{children}</MaterialAvatar>
    </Wrapper>
        
    );
}

export default Avatar;
